import { httpBatchLink, createTRPCProxyClient  } from '@trpc/react-query';
import { AppRouter } from '@/types/trpc.types';
import { createContext, useContext, useMemo } from 'react';
import { API_CONFIG } from '@/config/api.config';

interface Context {
    trpc: ReturnType<typeof createTRPCProxyClient<AppRouter>>;
}

const TrpcContext = createContext<Context>({} as Context);

export const TrpcProvider = ({ children }: { children: React.ReactNode }) => {
    const trpc = useMemo(()=> (
        createTRPCProxyClient<AppRouter>({
            links: [
                httpBatchLink({
                    url: `${API_CONFIG.trpcUrl}`,
                    fetch(url, options) {
                        return fetch(url, {
                          ...options,
                          credentials: 'include',
                        });
                    },
                }),
            ],
        })
    ), [])    

    return (
        <TrpcContext.Provider value={{ trpc }}>
            {children}
        </TrpcContext.Provider>
    );
};

export const useTRPC = () => useContext(TrpcContext);